/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type UpdateWidgetRequestBody = {
  /**
   * Catalog dataset the widget asks
   */
  dataset: string;
  /**
   * What the widget is for, at most 2000 characters
   */
  description?: string | undefined;
  /**
   * The widget to update
   */
  id: string;
  /**
   * Display name, at most 200 characters
   */
  name: string;
  /**
   * The question. Validated against the catalog on save.
   */
  query: { [k: string]: any };
  /**
   * How the question is drawn. Checked against the question on save.
   */
  visualization: { [k: string]: any };
};

/** @internal */
export type UpdateWidgetRequestBody$Outbound = {
  dataset: string;
  description?: string | undefined;
  id: string;
  name: string;
  query: { [k: string]: any };
  visualization: { [k: string]: any };
};

/** @internal */
export const UpdateWidgetRequestBody$outboundSchema: z.ZodMiniType<
  UpdateWidgetRequestBody$Outbound,
  UpdateWidgetRequestBody
> = z.object({
  dataset: z.string(),
  description: z.optional(z.string()),
  id: z.string(),
  name: z.string(),
  query: z.record(z.string(), z.any()),
  visualization: z.record(z.string(), z.any()),
});

export function updateWidgetRequestBodyToJSON(
  updateWidgetRequestBody: UpdateWidgetRequestBody,
): string {
  return JSON.stringify(
    UpdateWidgetRequestBody$outboundSchema.parse(updateWidgetRequestBody),
  );
}
